import { useEffect, useRef } from 'react'

import { useAppSelector } from 'reduxTyped'
import { getIsAnnualExpansionNotificationEligible } from 'apps/dashboard/helpers/annualExpansion/annualExpansionSelectors'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'
import { useExposedFlagEventIfExists } from 'utils/services/featureFlagsService/useExposedFlagEventIfExists'

/**
 * Sends the experiment exposure event for both arms once the account becomes eligible for the
 * annual expansion notification. Lives outside of the notification itself, because the DISABLE
 * arm never renders it.
 */
export const useAnnualExpansionExposure = () => {
  const isEligible = useAppSelector(getIsAnnualExpansionNotificationEligible)
  const exposeExperiment = useExposedFlagEventIfExists()
  const isExposedRef = useRef(false)

  useEffect(() => {
    if (!isEligible || isExposedRef.current) {
      return
    }

    isExposedRef.current = true
    exposeExperiment([AccountFlag.ENABLE_ANNUAL_EXPANSION, AccountFlag.DISABLE_ANNUAL_EXPANSION])
  }, [isEligible, exposeExperiment])
}
